import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';

@Component({
  selector: 'app-promo-canal-vendedor-form',
  templateUrl: './promo-canal-vendedor-form.component.html',
  styleUrls: ['./promo-canal-vendedor-form.component.css']
})
export class PromoCanalVendedorFormComponent implements OnInit {

  agregarFormCondicion!: FormGroup;
  public comboList: any[];
  columnDefs: any[] = [{field: 'id_canal_cliente', sortable: true}];

  @Input()
  set idPromo(id: string) {
    this.agregarFormCondicion.get('id_promo').setValue(id);
  }

  @Input()
  idCondicionInput: string[];

  @Output()
  back = new EventEmitter<void>();

  @Output()
  create = new EventEmitter<any>();

  @Output()
  columnasGrid: EventEmitter<any[]> = new EventEmitter<any[]>();

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly dmaestrosServices : DatosMaestrosService
  ) {
    this.buildForm();
  }

  ngOnInit(): void {
    this.columnDefs = [
      {field: 'id_canal_cliente', sortable: true},
      {field: 'descCorta', sortable: true, filter: true, headerName: 'Detalle'}
    ];
    console.log("field", this.columnDefs);
    this.columnasGrid.emit(this.columnDefs);
    this.inicializarCombo();
  }

  private buildForm() {
    this.agregarFormCondicion = this.formBuilder.group({
      id_promo    : ['', [Validators.required]],
      id_canal_cliente: ['', [Validators.required]]
    })
  }

  inicializarCombo() {
    this.comboList = [];
    this.dmaestrosServices.getAllCanalVendedor().subscribe(
      (resp)  => { if (resp) this.comboList = resp; console.log("COMBO ", resp)},
      (error) => { this.comboList = []; }
    );
  }

  acciones(event: string) {
    if (event === 'guardar') {
      this.create.emit(this.agregarFormCondicion.getRawValue());
    } else {
      this.back.emit();
    }
  }

}
